import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: '',
  count: 0,
};

const appLayoutReducer = createSlice({
  name: 'appLayout',
  initialState,
  reducers: {
    setBadgeCount(state, action) {
      state.count = action.payload;
    },
    setPageTitle(state, action) {
      state.title = action.payload;
    },
  },
});

export const { setBadgeCount, setPageTitle } = appLayoutReducer.actions;
export default appLayoutReducer.reducer;
